import { DefinitionDescription, DefinitionTerm } from "@/components/ui/definition-list.tsx";
import { useTranslations } from "@/features/translations/components/translations";
import { useAppSelector } from "@/redux/store.ts";

export default function FamilyDetails() {
    const t = useTranslations();

    const installations = useAppSelector((state) => state.installations.options);
    const installationId = useAppSelector((state) => state.installations.activeId);
    const family = useAppSelector((state) => state.subFamily.family);
    const subFamilyName = useAppSelector((state) => state.subFamily.name);

    const installation = installationId ? installations[installationId] : "";

    return (
        <>
            {!!subFamilyName && (
                <>
                    <DefinitionTerm>{t("family")}</DefinitionTerm>
                    <DefinitionDescription>{family}</DefinitionDescription>
                </>
            )}
            <DefinitionTerm>{t("installation")}</DefinitionTerm>
            <DefinitionDescription>{installation}</DefinitionDescription>
            {!!subFamilyName && (
                <>
                    <DefinitionTerm>{t("sub_family")}</DefinitionTerm>
                    <DefinitionDescription>{subFamilyName}</DefinitionDescription>
                </>
            )}
        </>
    );
}
